import type { MessageKey } from "./ru"

export const esMessages = {
  "common.loading": "Cargando...",
  "common.error": "Error",
  "common.back": "Atrás",
  "common.next": "Siguiente",
  "common.search": "Buscar",
  "auth.loginErrorTitle": "Error de inicio de sesión",
  "auth.openViaTelegram": "Abre la aplicación desde Telegram",
  "auth.telegramRequired": "La aplicación debe abrirse desde Telegram",
  "auth.authorizationError": "Error de autorización",
  "device.rotatePortrait": "Gira el dispositivo a posición vertical",
  "country.brazil": "Brasil",
  "country.vietnam": "Vietnam",
  "country.egypt": "Egipto",
  "country.india": "India",
  "country.indonesia": "Indonesia",
  "country.iran": "Irán",
  "country.spain": "España",
  "country.italy": "Italia",
  "country.kazakhstan": "Kazajistán",
  "country.colombia": "Colombia",
  "country.malaysia": "Malasia",
  "country.mexico": "México",
  "country.nigeria": "Nigeria",
  "country.pakistan": "Pakistán",
  "country.russia": "Rusia",
  "country.usa": "Estados Unidos",
  "country.turkey": "Turquía",
  "country.uzbekistan": "Uzbekistán",
  "country.ukraine": "Ucrania",
  "country.philippines": "Filipinas",
  "countrySelection.chooseCountry": "Elige un país",
  "countrySelection.openAria": "Elegir un país",
  "languageSelection.chooseLanguage": "Elige un idioma",
  "commercial.direction.autotrade": "AutoTorg",
  "commercial.direction.insurance": "Seguro",
  "commercial.direction.pitstop": "Pit Stop",
  "commercial.direction.techhelp": "Asistencia en carretera",
  "commercial.searchLabel": "Búsqueda de BeepApp",
  "commercial.cityPlaceholder": "Introduce la ciudad",
  "commercial.emptyTitle": "No hay ofertas hoy",
  "commercial.emptyLine1": "Todavía no hay socios activos de BeepApp en tu ciudad",
  "commercial.emptyLine2": "Ya estamos trabajando para encontrarlos y conectarlos",
  "commercial.emptyLine3": "Las nuevas ofertas aparecerán aquí automáticamente",
  "commercial.helperLine1": "Indica tu ciudad para ver",
  "commercial.helperLine2": "las ofertas disponibles",
  "commercial.partnerPrompt": "¿Quieres ser socio de BeepApp?",
  "commercial.apply": "Enviar solicitud",
  "main.admin": "Admin",
  "main.garage": "Garaje",
  "main.signalSent": "Señal enviada",
  "main.partnerInviteUnavailable": "La invitación de socio no está disponible",
  "main.enterPlate": "Introduce la matrícula",
  "main.searchError": "Error de búsqueda",
  "main.signalSendError": "No se pudo enviar la señal",
  "main.shareCardPrefix": "Ficha de matrícula",
  "main.shareLinkError": "No se pudo preparar el enlace",
  "main.searchByPlateAria": "Buscar por matrícula",
  "main.russianPlateAria": "Matrícula rusa",
  "main.plateAria": "Matrícula",
  "main.findPlateAria": "Buscar matrícula",
  "main.loadingVehicle": "Cargando ficha de matrícula…",
  "main.leaveSignal": "Enviar una señal",
  "main.share": "Compartir",
  "signalSelection.chooseType": "Elige el tipo de señal",
  "signalSelection.category.attention": "Personales",
  "signalSelection.category.road": "Carretera",
  "signalSelection.category.urgent": "Urgentes",
  "signalSelection.chooseSignal": "Elige una señal",
  "signalSelection.suggestOwn": "Proponer otra opción",
  "signalConfirmation.title": "Confirmar señal",
  "signalConfirmation.plateHeading": "Comprueba la matrícula",
  "signalConfirmation.signalHeading": "Comprueba la señal seleccionada",
  "signalConfirmation.replyTitle": "Permitir respuesta en Telegram",
  "signalConfirmation.replyBody": "Activa esta función para que el titular de la matrícula pueda\nescribirte en Telegram. Solo podrá responder si tienes\nun @username. La decisión de responder seguirá siendo\ndel titular de la matrícula.",
  "signalConfirmation.consentText": "Confirmo que la señal corresponde\na una situación real y no es spam\nni una denuncia falsa.",
  "signalConfirmation.warning": "Después de enviarla, la señal\nno se podrá cambiar",
  "signalConfirmation.sending": "Enviando…",
  "signalConfirmation.send": "Enviar",
  "partner.loadingAria": "Cargando",
  "partner.title": "Programa de socios",
  "partner.offerLine1": "Recibe un 30% de todos los pagos sin límite de tiempo",
  "partner.offerLine2": "de los usuarios que invites a BeepApp",
  "partner.offerLine3": "mediante el programa de afiliados de Telegram",
  "partner.connectUnavailable": "La conexión estará disponible cuando se configure el programa de afiliados de Telegram.",
  "partner.connectTelegram": "Conectarse en Telegram",
  "partner.qrAria": "Código QR del enlace de socio",
  "partner.download": "Descargar",
  "partner.promoHeading": "Crea un código promocional personal",
  "partner.promoHelperLine1": "El código promocional activa un año extra de suscripción",
  "partner.promoHelperLine2": "y ayuda a atraer usuarios",
  "partner.promoAria": "Código promocional",
  "partner.affiliateHeading": "Tu enlace de afiliado",
  "partner.affiliateHelper": "Guarda el enlace para crear un código QR personal",
  "partner.affiliateAria": "Enlace de afiliado",
  "partner.qrNoteLine1": "Puedes colocar el código QR en tu vehículo,",
  "partner.qrNoteLine2": "en redes sociales y materiales publicitarios",
  "partner.save": "Guardar",
  "partner.reset": "Restablecer",
  "partner.resetConfirm": "¿Restablecer el enlace de afiliado guardado? El código promocional seguirá siendo tuyo.",
  "partner.promoFormatError": "El código promocional debe tener entre 4 y 15 caracteres.",
  "partner.affiliateHostError": "Solo se permiten enlaces t.me o telegram.me.",
  "partner.affiliatePathError": "El enlace no contiene una ruta de Telegram.",
  "partner.affiliateFormatError": "Enlace de afiliado no válido.",
  "partner.loadError": "Error de carga",
  "partner.checkInputError": "Comprueba los datos introducidos",
  "garageActivation.promoInvalid": "El código promocional no es válido",
  "garageActivation.plateOccupied": "Esta matrícula ya está vinculada",
  "garageActivation.activateError": "No se pudo activar el Garaje",
  "garageEntry.loadJournalError": "No se pudo cargar el registro",
  "garageEntry.loadStatusesError": "No se pudieron cargar los estados",
  "garageEntry.activationSuccess": "Garaje activado correctamente",
  "garageEntry.plateAttached": "Matrícula vinculada",
  "garageEntry.attachError": "No se pudo vincular la matrícula",
  "garageEntry.activationNote": "Activa tu Garaje",
  "garageSheet.activationTitle": "Activación del Garaje",
  "garageSheet.plateHelper": "Introduce la matrícula del vehículo",
  "garageSheet.promoHelper": "¿Tienes un código promocional?",
  "garageSheet.cleanBonusLine1": "Después de la activación tendrás 1 hora",
  "garageSheet.cleanBonusLine2": "para un «Inicio limpio» gratuito",
  "garageSheet.activationFor": "Activación por",
  "garageSheet.cost": "Coste",
  "garageSheet.ownerConsentLine1": "Confirmo que soy el propietario",
  "garageSheet.ownerConsentLine2": "del vehículo con la matrícula",
  "garageSheet.ownerConsentLine3": "indicada.",
  "garageSheet.processing": "Procesando...",
  "garageSheet.attach": "Vincular",
  "garageSheet.pay": "Pagar",
  "garageLifecycle.cleanTitle": "Inicio limpio",
  "garageLifecycle.deactivateTitle": "Desactivación del Garaje",
  "garageLifecycle.cleanWarningLine1": "Se eliminará el historial de la matrícula",
  "garageLifecycle.cleanWarningLine2": "sin posibilidad de recuperarlo.",
  "garageLifecycle.deactivateWarningLine1": "Después de la desactivación, se perderá el acceso",
  "garageLifecycle.deactivateWarningLine2": "a las funciones del Garaje activo",
  "garageLifecycle.willBeDeleted": "SE ELIMINARÁ",
  "garageLifecycle.cleanRemovedLine1": "• Todas las entradas del Registro",
  "garageLifecycle.cleanRemovedLine2": "• Historial de señales recibidas",
  "garageLifecycle.cleanRemovedLine3": "• Contadores públicos de señales",
  "garageLifecycle.cleanRemovedLine4": "  en la ficha de matrícula",
  "garageLifecycle.willRemain": "SE CONSERVARÁ",
  "garageLifecycle.cleanPreservedLine1": "• Vinculación de la matrícula al Garaje",
  "garageLifecycle.cleanPreservedLine2": "• Periodo de activación restante",
  "garageLifecycle.cleanPreservedLine3": "• Estado de matrícula seleccionado",
  "garageLifecycle.cleanPreservedLine4": "• Número total de vistas de la ficha",
  "garageLifecycle.freeFirstHour": "Gratis durante la primera hora",
  "garageLifecycle.willBecomeUnavailable": "DEJARÁ DE ESTAR DISPONIBLE",
  "garageLifecycle.deactivateRemovedLine1": "• Registro",
  "garageLifecycle.deactivateRemovedLine2": "• Selección y uso del estado de matrícula",
  "garageLifecycle.deactivateRemovedLine3": "• Saldrás automáticamente de AutoClan",
  "garageLifecycle.deactivateRemovedLine4": "• AutoTorg",
  "garageLifecycle.deactivateRemovedLine5": "• Seguro",
  "garageLifecycle.deactivateRemovedLine6": "• Pit Stop",
  "garageLifecycle.deactivateRemovedLine7": "• Asistencia en carretera",
  "garageLifecycle.deactivateRemovedLine8": "• La matrícula se desvinculará del Garaje",
  "garageLifecycle.willRemainAvailable": "SEGUIRÁN DISPONIBLES",
  "garageLifecycle.deactivatePreservedLine1": "• Compañero de viaje",
  "garageLifecycle.deactivatePreservedLine2": "• Despachador",
  "garageLifecycle.deactivatePreservedLine3": "• Búsqueda por matrícula y visualización",
  "garageLifecycle.deactivatePreservedLine4": "  de la ficha pública del vehículo",
  "garageLifecycle.deactivatePreservedLine5": "• Posibilidad de volver a activar",
  "garageLifecycle.deactivatePreservedLine6": "  el Garaje en cualquier momento",
  "garageLifecycle.cleanConsentLine1": "Confirmo mi consentimiento para eliminar",
  "garageLifecycle.cleanConsentLine2": "todo el historial de esta matrícula",
  "garageLifecycle.cleanConsentLine3": "sin posibilidad de recuperarlo.",
  "garageLifecycle.deactivateConsentLine1": "Confirmo la desactivación y",
  "garageLifecycle.deactivateConsentLine2": "la finalización del acceso a todas",
  "garageLifecycle.deactivateConsentLine3": "las funciones del Garaje activo.",
  "garageLifecycle.clean": "Eliminar",
  "garageLifecycle.deactivate": "Desactivar",
} satisfies Record<MessageKey, string>
